var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_4724",
    "data-name": "Grupo 4724",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.847,
    height: 18.847,
    viewBox: "0 0 18.847 18.847",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3704",
    "data-name": "Caminho 3704",
    d: "M0,0H18.847V18.847H0Z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3705",
    "data-name": "Caminho 3705",
    d: "M3,14.19v2.945H5.945L14.63,8.449,11.685,5.5ZM16.908,6.172a.782.782,0,0,0,0-1.107L15.07,3.227a.782.782,0,0,0-1.107,0L12.526,4.664l2.945,2.945,1.437-1.437Z",
    transform: "translate(-0.644 -0.644)",
    fill: "#696969",
    stroke: "#000",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEdit);
export default __webpack_public_path__ + "static/media/ico-edit.9935b22d1cd7c14331dc15551ced70bb.svg";
export { ForwardRef as ReactComponent };